import { Component, OnInit } from '@angular/core';
import { authenticationService } from 'src/app/Services/Authentication/authentication.service';
import { ViewController } from '@ionic/core';
import { PopoverController, AlertController } from '@ionic/angular';
import { SharedService } from 'src/app/Services/sheared/sharedService.service';



@Component({
  selector: 'app-popovercompo',
  templateUrl: './popovercompo.component.html',
  styleUrls: ['./popovercompo.component.scss'],
})
export class PopovercompoComponent implements OnInit {

  constructor(private viewCtrl:PopoverController,
              private shear:SharedService ,private alertController:AlertController,
              private auth:authenticationService
              ) {  }

  ngOnInit() {}
  async presentConfirm() {
    const alert = await this.alertController.create({
      header: 'Confirmation !',
      message: 'Voulez-vous vraiment quitter AsapAssur ?',
      // mode:'ios',
      buttons: [
        {
          text: 'Annuler',
          role: 'cancel',
          cssClass: 'primary',
          handler: () => {
            //this._objet = "Selectionner l'objet"
          }
        },
        {
          text: 'Oui',
          handler: (data: []) => {
            this.auth.onLogout()
           
          }
        }
      ]
    
    });
    await alert.present();
  }
  onLogout(){
  
    //this.auth.onLogout()
    this.presentConfirm()
    this.viewCtrl.dismiss();
  
  }
  onApropos(){
    
  }
  onHistorique(){

  }
  onResponse(){

  }
}
